import { Permission } from '../../modules/Login/hooks/types'

type Action =
  | { type: 'logOut' }
  | { type: 'logIn'; payload: UserAuth }
  | { type: 'areaSelected'; payload: AreaSelected }
  | { type: 'setTokenUrlWeb', payload: {urlTokenSetted: boolean} }

export type AreaSelected = 'sweetWater' | 'seaWater' | 'health' | 'logistic' | null

export interface InfoUser {
  lastUserLogged: { email: string; password: string; remember: boolean } | null
  users: { [key: string]: UserAuth | null }
  getTokenUrl: boolean
  tokenType: string
}

export interface UserAuth {
  userId: number | null
  userName: string | null
  status: 'checking' | 'authorized' | 'not-authorized'
  areaSelected: AreaSelected
  password: string | null
  email: string | null
  token: string | null
  assignedAreas: number | null
  permissions: Permission[] | null
  remember: boolean
  tokenType: string
}

export const authReducer = (state: InfoUser, action: Action): InfoUser => {
  switch (action.type) {
    case 'logIn':
      const { email, password, remember } = action.payload
      return {
        ...state,
        lastUserLogged: { email: email!, password: password!, remember },
        users: {
          ...state.users,
          [email!]: { ...action.payload },
        },
        getTokenUrl: true,
        tokenType: action.payload.tokenType
      }

    case 'logOut':
      const lastEmail = state.lastUserLogged?.email
      return {
        ...state,
        getTokenUrl: false,
        users: {
          ...state.users,
          ...(lastEmail && {
            [lastEmail]: {
              ...state.users[state.lastUserLogged!.email]!,
              status: 'not-authorized'
            },
          }),
        },
      }

    case 'areaSelected':
      return {
        ...state,
        users: {
          ...state.users,
          [state.lastUserLogged!.email]: {
            ...state.users[state.lastUserLogged!.email]!,
            areaSelected: action.payload,
          },
        },
      }
    case 'setTokenUrlWeb':
      return {
        ...state,
        getTokenUrl: action.payload.urlTokenSetted
      }
    default:
      return state
  }
}
